/* Bowtie Plant Co. storefront boosters
   - quick-add buttons on collection cards
   - sticky B3G4 progress bar
   - Palmstreet social proof + Arrive Alive block on product pages
   - cross-sell (substrate <-> seedling)
   - single-photo listings: "more photos coming soon" + request button
*/
(function () {
  var SEED_COLLECTION = 'available-seedlings';
  var FREE_SHIP = 49;
  var SUBSTRATE_HANDLE = 'the-dirty-bowtie-semi-hydro-plant-substrate';
  var SUBSTRATE_VARIANT = 43115463999547;
  var MYSTERY_HANDLE = 'mystery-10-pack-anthurium-seedlings';
  /* Bigger, readable Palmstreet card (Nick, 2026-09-05). Served as a theme asset so it
     can be replaced with one asset PUT. */
  var PS_CARD = '/cdn/shop/t/2/assets/ps-card-v2.png';

  var seedHandles = {};
  var seedList = [];
  var loaded = false;

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  /* Never hard-code prices (Nick, 2026-10-16): fill [data-live-price] from the live product JSON. */
  function livePrice(root, handle, variantId) {
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return !variantId || x.id === variantId; })[0] || (p.variants || [])[0];
      if (!v) return;
      Array.prototype.forEach.call(root.querySelectorAll('[data-live-price]'), function (el) { el.innerHTML = money(v.price); el.style.display = ''; });
    }).catch(function () {});
  }

  function loadSeedlings() {
    if (loaded) return Promise.resolve();
    return fetch('/collections/' + SEED_COLLECTION + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        (d.products || []).forEach(function (p) {
          var v = (p.variants || [])[0];
          if (!v) return;
          seedHandles[p.handle] = { id: v.id, price: v.price, available: v.available, title: p.title,
            img: (p.images && p.images[0]) ? p.images[0].src : null,
            imgs: (p.images || []).slice(0, 5).map(function (im) { return im.src; }) };
          if (v.available) seedList.push(p.handle);
        });
        loaded = true;
      })
      .catch(function () { loaded = true; });
  }

  /* ---------- sticky progress bar ---------- */
  var bar;
  function ensureBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.id = 'bt-progress';
    bar.innerHTML = '<div class="bt-p-inner"><div class="bt-p-msg"></div><div class="bt-p-track"><div class="bt-p-fill"></div></div></div>' +
      '<button type="button" class="bt-p-x" aria-label="Dismiss">&times;</button>';
    bar.addEventListener('click', function (e) {
      var x = e.target.closest ? e.target.closest('.bt-p-x') : null;
      if (!x) return;
      e.preventDefault();
      try {
        sessionStorage.setItem('btBarDismissed', '1');
        var n = parseInt(sessionStorage.getItem('btBarDismissCount') || '0', 10);
        sessionStorage.setItem('btBarDismissCount', String(n + 1));
      } catch (err) {}
      applyVisibility();
    });
    /* Cart page: the bar is rendered INLINE above the cart items instead of fixed at
       the top, where it duplicated the cart's own shipping line and covered Check out
       (Nick, 2026-09-04). Everywhere else it stays fixed under the header. */
    var cartHost = null, cartAfter = false;
    if (/^\/cart(\/|$|\?)/.test(window.location.pathname)) {
      /* Nick, 2026-09-06: the bar + seedling picker sat ABOVE the item list, pushing
         "Your cart" and Check out off the first screen. Anchor them AFTER the cart
         footer (the block that holds subtotal + Check out) instead. */
      cartHost = document.querySelector('#main-cart-footer, .cart__footer');
      if (cartHost) { cartAfter = true; }
      else { cartHost = document.querySelector('#main-cart-items .cart__items, .cart__items, cart-items'); }
    }
    if (cartHost) {
      bar.classList.add('bt-inline');
      cartHost.parentNode.insertBefore(bar, cartAfter ? cartHost.nextSibling : cartHost);
      return bar;
    }
    document.body.appendChild(bar);
    positionBar();
    window.addEventListener('scroll', positionBar, { passive: true });
    window.addEventListener('resize', positionBar);
    window.addEventListener('load', positionBar);
    /* Late layout shifts (web fonts, banner slideshow changing height) */
    [200, 600, 1500, 3000].forEach(function (t) { setTimeout(positionBar, t); });
    if (window.ResizeObserver) {
      var hg = document.querySelector('.shopify-section-group-header-group');
      if (hg && hg.parentNode) { try { new ResizeObserver(positionBar).observe(hg.parentNode); } catch (e) {} }
    }
    return bar;
  }
  /* The bar lives at the TOP of the viewport (Nick, 2026-09-04): at the bottom it
     covered the sticky Add-to-cart bar on product pages. It has to sit UNDER whatever
     sticky chrome is pinned at the top (announcement bar / header), so the offset is
     measured live rather than hard-coded. */
  function positionBar() {
    if (!bar) return;
    var off = 0;
    var chrome = document.querySelectorAll('.shopify-section-group-header-group, .announcement-bar, .utility-bar');
    Array.prototype.forEach.call(chrome, function (el) {
      var r = el.getBoundingClientRect();
      /* Any header-group chrome still occupying the top of the screen (announcement
         banner at page top, sticky header once pinned) pushes the bar down. No
         hard-coded top gate: the banner can wrap to 2-3 lines on narrow phones and
         push the header well down the screen (Nick, 2026-09-04). */
      if (r.height && r.bottom > off && r.top < window.innerHeight * 0.5 && r.bottom < 400) off = r.bottom;
    });
    document.documentElement.style.setProperty('--bt-p-top', Math.max(0, Math.round(off)) + 'px');
  }
  function seedCount(cart) {
    var n = 0;
    (cart.items || []).forEach(function (i) { if (seedHandles[i.handle]) n += i.quantity; });
    return n;
  }
  var lastItemCount = null;
  function renderBar(cart) {
    var b = ensureBar(), n = seedCount(cart), subtotal = (cart.total_price || 0) / 100, msg, pct;
    var count = cart.item_count || 0;
    if (lastItemCount !== null && count > lastItemCount) allowReentry();
    lastItemCount = count;
    /* Always visible, even with no seedlings in the cart — it doubles as the B3G4
       offer announcement for cold visitors (Nick, 2026-09-04) */
    /* Short, one-line copy — the bar was two lines tall on phones (Nick, 2026-09-05) */
    /* B3G4 retired 2026-10-17 (Nick): bar is now a free-shipping nudge only, hidden on an empty cart. */
    if (count === 0 || subtotal <= 0) {
      barReady = false; b.classList.remove('bt-show'); document.body.classList.remove('bt-bar-on'); return;
    }
    if (subtotal < FREE_SHIP) { msg = '<strong>' + money((FREE_SHIP - subtotal) * 100) + '</strong> to free shipping'; pct = (subtotal / FREE_SHIP) * 100; }
    else { msg = '&#127881; <strong>Free shipping unlocked</strong>'; pct = 100; }
    /* On the cart page "View cart" is a dead link — point at seedlings instead (Nick, 2026-09-04) */
    var link = (b.classList.contains('bt-inline') || n === 0)
      ? ' <a href="/collections/available-seedlings-manual" class="bt-p-link">Add seedlings &rarr;</a>'
      : ' <a href="/cart" class="bt-p-link">View cart &rarr;</a>';
    b.querySelector('.bt-p-msg').innerHTML = msg + link;
    b.querySelector('.bt-p-fill').style.width = Math.min(pct, 100) + '%';
    barReady = true;
    applyVisibility();
    positionBar();
  }
  /* Homepage: stay out of the hero, only appear once they scroll past it (Nick, 2026-09-04) */
  var barReady = false;
  var HOME_SCROLL = 400;
  function isHome() { return /^\/(\?|$)/.test(window.location.pathname); }
  /* Hide while a lightbox / media modal is open, and honor the dismiss X (Nick, 2026-09-05) */
  function modalOpen() {
    return !!document.querySelector('.product-media-modal[open], product-modal[open], dialog[open], .modal__content[open], body.overflow-hidden .product-media-modal');
  }
  function dismissed() {
    try { return sessionStorage.getItem('btBarDismissed') === '1'; } catch (e) { return false; }
  }
  /* One re-entry: adding another item un-dismisses the bar once. Dismiss it twice and it
     stays gone for the session. (Nick, 2026-09-05) */
  function allowReentry() {
    try {
      var n = parseInt(sessionStorage.getItem('btBarDismissCount') || '0', 10);
      if (n < 2) sessionStorage.removeItem('btBarDismissed');
    } catch (e) {}
  }
  function applyVisibility() {
    var b = ensureBar();
    if (!barReady) return;
    if (b.classList.contains('bt-inline')) { b.classList.add('bt-show'); return; }
    if (dismissed() || modalOpen()) {
      b.classList.remove('bt-show');
      document.body.classList.remove('bt-bar-on');
      return;
    }
    if (isHome() && (window.pageYOffset || document.documentElement.scrollTop) < HOME_SCROLL) {
      b.classList.remove('bt-show');
      document.body.classList.remove('bt-bar-on');
      return;
    }
    b.classList.add('bt-show');
    document.body.classList.add('bt-bar-on');
  }
  window.addEventListener('scroll', applyVisibility, { passive: true });
  /* Prev/next plant arrows: they get in the way while reading, so they fade back
     to a ghost while you scroll and come back solid a moment after you stop.
     Plain throttled scroll handler — no observers on this theme. (Nick, 2026-09-05) */
  var fabTimer = null;
  function fabScroll() {
    var f = document.querySelector('.bt-fab');
    if (!f) return;
    f.classList.add('bt-fab-idle');
    if (fabTimer) clearTimeout(fabTimer);
    fabTimer = setTimeout(function () { f.classList.remove('bt-fab-idle'); }, 900);
  }
  window.addEventListener('scroll', fabScroll, { passive: true });

  /* React to lightbox open/close.
     2026-09-05: this used to be a MutationObserver on documentElement with
     subtree+attributes. On this store (huge DOM + Judge.me widgets mutating classes
     constantly) it fired thousands of times a second, each run doing a full-document
     querySelector — the page locked up and the site looked "broken" (Nick, 2026-09-05).
     NEVER put an unthrottled whole-document attribute observer on this theme.
     A 400ms poll does the same job for free. */
  setInterval(applyVisibility, 400);
  function refresh() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { renderBar(c); cartSeedPicker(c); }).catch(function () {}); }

  /* ---- cart-page roller tracking (Nick, 2026-09-07). Attribution used to be
     impossible: a roller add and a normal add looked identical on the order. */
  var CRT = { rolls: 0, backs: 0, locks: 0, adds: 0, t0: Date.now(), seen: {}, seenN: 0, log: [], sid: '', tester: '' };
  try {
    var _ss = window.sessionStorage;
    CRT.sid = _ss.getItem('bwt_sid') || (Date.now().toString(36) + Math.random().toString(36).slice(2, 7));
    _ss.setItem('bwt_sid', CRT.sid);
    var _qt = (location.search.match(/[?&]rollertest=([^&]+)/) || [])[1];
    if (_qt) _ss.setItem('bwt_tester', decodeURIComponent(_qt));
    CRT.tester = _ss.getItem('bwt_tester') || '';
  } catch (e) { CRT.sid = Math.random().toString(36).slice(2, 9); }
  if (!CRT.tester && navigator.webdriver) CRT.tester = 'automation';
  function crtWho() {
    var cid = '';
    try {
      cid = (window.__st && window.__st.cid) ||
        (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page &&
          ShopifyAnalytics.meta.page.customerId) || '';
    } catch (e) {}
    if (CRT.tester) return 'TEST:' + CRT.tester;
    return cid ? 'customer ' + cid : 'guest';
  }
  function crtLog(action, detail) {
    var t = Math.round((Date.now() - CRT.t0) / 1000);
    CRT.log.push(t + 's ' + action + (detail ? ':' + detail : ''));
    if (CRT.log.length > 80) CRT.log.shift();
  }
  function crtSee(list) {
    (list || []).forEach(function (h) { if (h && !CRT.seen[h]) { CRT.seen[h] = 1; CRT.seenN++; } });
  }
  function crtStamp(title) {
    /* counters are per page load; the cart carries the running totals across reloads */
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var a = c.attributes || {};
      var prevAdds = parseInt(a['Cart roller adds'] || '0', 10) || 0;
      var prevRolls = parseInt(a['Cart roller rolls'] || '0', 10) || 0;
      var prevSeen = parseInt(a['Cart roller seen'] || '0', 10) || 0;
      var picked = (a['Cart roller picked'] ? a['Cart roller picked'] + ' | ' : '') + title;
      if (picked.length > 480) picked = picked.slice(-479);
      var log = (a['Cart roller actions'] ? a['Cart roller actions'] + ' | ' : '') + CRT.log.join(' | ');
      if (log.length > 480) log = log.slice(-479);
      return fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: {
          'Cart roller': 'yes',
          'Cart roller adds': String(prevAdds + 1),
          'Cart roller rolls': String(prevRolls + CRT.rolls),
          'Cart roller go-backs': String(CRT.backs),
          'Cart roller locked in': String(CRT.locks),
          'Cart roller seen': String(prevSeen + CRT.seenN),
          'Cart roller seconds': String(Math.round((Date.now() - CRT.t0) / 1000)),
          'Cart roller picked': picked,
          'Cart roller who': crtWho(),
          'Cart roller session': CRT.sid,
          'Cart roller actions': log,
          'Cart roller last add at': new Date().toISOString().replace('T', ' ').slice(0, 19) + ' UTC'
        } })
      });
    }).catch(function () {});
  }

  function addToCart(variantId, btn, doneLabel, props) {
    btn.disabled = true;
    var old = btn.innerHTML;
    btn.innerHTML = 'Adding&hellip;';
    var item = { id: variantId, quantity: 1 };
    if (props) item.properties = props;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { return r.json(); })
      .then(function () { btn.innerHTML = doneLabel || '&#10003; Added'; btn.classList.add('bt-added'); return refresh(); })
      .catch(function () { btn.innerHTML = old; btn.disabled = false; });
  }

  /* ---------- collection quick-add ---------- */
  function cardHandle(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }
  function decorate() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.dataset.btQa || card.querySelector('.bt-qa')) return;
      var h = cardHandle(card);
      if (!h || !seedHandles[h]) return;
      card.dataset.btQa = '1';
      var info = seedHandles[h];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bt-qa';
      btn.innerHTML = info.available ? 'Add &middot; $' + info.price : 'Sold';
      if (!info.available) btn.disabled = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (!btn.disabled) addToCart(info.id, btn);
      });
      card.appendChild(btn);
      var gi = card.closest('.grid__item') || card.parentElement;
      if (gi) gi.classList.add('bt-has-qa');
    });
  }

  /* ---------- product page blocks ---------- */
  function productHandle() {
    var m = location.pathname.match(/\/products\/([^?#\/]+)/);
    return m ? m[1] : null;
  }
  function infoContainer() {
    return document.querySelector('.product__info-container') || document.querySelector('.product__info-wrapper') || document.querySelector('main');
  }

  function proofBlock() {
    var d = document.createElement('div');
    d.className = 'bt-proof';
    d.innerHTML =
      '<div class="bt-proof-stats"><span><strong>4.9&#9733;</strong> rating</span><span><strong>1,199</strong> reviews</span><span><strong>17,229</strong> sales</span></div>' +
      '<div class="bt-proof-sub">Our track record selling live on Palmstreet as <strong>@BowtiePlantCo</strong></div>' +
      '<a class="bt-guarantee" href="/pages/arrive-alive">' +
      '<span class="bt-g-title">&#128737; Arrive Alive Guarantee</span>' +
      '<span class="bt-g-body">Damaged or dead on arrival? Send photos within 48 hours and we replace it or refund you. We hold orders when it is too cold to ship.</span>' +
      '<span class="bt-g-link">Read the guarantee &rarr;</span></a>';
    return d;
  }

  function crossSell(handle) {
    var d = document.createElement('div');
    d.className = 'bt-cross';
    if (handle === SUBSTRATE_HANDLE) {
      var pick = seedList.length ? seedHandles[seedList[Math.floor(Math.random() * seedList.length)]] : null;
      if (!pick) return null;
      d.innerHTML = '<div class="bt-cross-h">Add a plant to grow in it</div>' +
        '<div class="bt-cross-row">' +
        (pick.img ? '<img src="' + pick.img + '" alt="">' : '') +
        '<div class="bt-cross-txt"><div class="bt-cross-t">' + pick.title + '</div>' +
        '<div class="bt-cross-p">$' + pick.price + ' &middot; named cross, grown in-house</div></div>' +
        '<button type="button" class="bt-cross-btn">Add</button></div>' +
        '<a class="bt-cross-more" href="/products/' + MYSTERY_HANDLE + '">Or grab the Mystery 10-Pack &rarr;</a>';
      d.querySelector('.bt-cross-btn').addEventListener('click', function (e) { addToCart(pick.id, e.currentTarget); });
    } else if (seedHandles[handle] || handle === MYSTERY_HANDLE) {
      d.innerHTML = '<div class="bt-cross-h">What we grow ours in</div>' +
        '<div class="bt-cross-row">' +
        '<div class="bt-cross-txt"><div class="bt-cross-t">The Dirty Bowtie&trade; Semi-Hydro Substrate</div>' +
        '<div class="bt-cross-p"><span data-live-price style="display:none"></span> 5 gal &middot; wick optional &middot; free shipping</div></div>' +
        '<button type="button" class="bt-cross-btn">Add</button></div>';
      livePrice(d, SUBSTRATE_HANDLE, SUBSTRATE_VARIANT);
      d.querySelector('.bt-cross-btn').addEventListener('click', function (e) { addToCart(SUBSTRATE_VARIANT, e.currentTarget); });
    } else { return null; }
    return d;
  }

  function photoRequest(handle) {
    var d = document.createElement('div');
    d.className = 'bt-morepics';
    d.innerHTML = '<div class="bt-mp-h">&#128247; More photos coming soon</div>' +
      '<div class="bt-mp-b">This one only has a single photo up so far. Want more angles before you buy? Tell us where to send them and we will shoot it for you.</div>' +
      '<form class="bt-mp-form"><input type="email" required placeholder="your@email.com" class="bt-mp-email"><button type="submit" class="bt-mp-btn">Send me photos</button></form>' +
      '<div class="bt-mp-done" hidden>&#10003; Got it &mdash; we will email you photos of this plant.</div>';
    var form = d.querySelector('.bt-mp-form');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = d.querySelector('.bt-mp-email').value;
      var btn = d.querySelector('.bt-mp-btn');
      btn.disabled = true; btn.textContent = 'Sending...';
      var fd = new FormData();
      fd.append('form_type', 'contact');
      fd.append('utf8', '\u2713');
      fd.append('contact[email]', email);
      fd.append('contact[body]', 'PHOTO REQUEST for ' + document.title + '\n' + location.href);
      fetch('/contact', { method: 'POST', body: fd })
        .then(function () { form.hidden = true; d.querySelector('.bt-mp-done').hidden = false; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
    });
    return d;
  }

  function productPage() {
    var handle = productHandle();
    if (!handle) return;
    var host = infoContainer();
    if (!host || host.dataset.btProduct) return;
    host.dataset.btProduct = '1';
    fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var frag = document.createDocumentFragment();
      if ((p.images || []).length <= 1 && p.available && handle !== MYSTERY_HANDLE) frag.appendChild(photoRequest(handle));
      frag.appendChild(proofBlock());
      var cs = crossSell(handle);
      if (cs) frag.appendChild(cs);
      host.appendChild(frag);
      refresh();
    }).catch(function () {});
  }

  /* ---------- push single-photo cards to the end of the grid ---------- */
  function sinkSinglePhoto() {
    if (!/\/collections\//.test(location.pathname)) return;
    var grid = document.querySelector('.product-grid, .grid--quarter, ul.grid');
    if (!grid || grid.dataset.btSunk) return;
    fetch(location.pathname.replace(/\/$/, '') + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var single = {};
        (d.products || []).forEach(function (p) { if ((p.images || []).length <= 1) single[p.handle] = 1; });
        singleMap = single;
        var moved = [];
        grid.querySelectorAll(':scope > li, :scope > .grid__item').forEach(function (li) {
          var card = li.querySelector('.card-wrapper') || li;
          var h = cardHandle(card);
          if (h && single[h]) { li.classList.add('bt-nophoto'); moved.push(li); }
        });
        moved.forEach(function (li) { grid.appendChild(li); });
        grid.dataset.btSunk = '1';
      })
      .catch(function () {});
  }


  /* ---------- collection infinite scroll ---------- */
  var singleMap = null;
  function markSingle(scope) {
    if (!singleMap) return;
    (scope || document).querySelectorAll('li, .grid__item').forEach(function (li) {
      var card = li.querySelector('.card-wrapper');
      if (!card) return;
      var h = cardHandle(card);
      if (h && singleMap[h]) li.classList.add('bt-nophoto');
    });
  }
  function colInfinite() {
    if (!/\/collections\//.test(location.pathname) || /\/products\//.test(location.pathname)) return;
    var grid = document.querySelector('#product-grid') || document.querySelector('.product-grid, ul.grid');
    if (!grid || grid.dataset.btInf) return;
    var wrap = document.querySelector('.pagination-wrapper');
    if (!wrap) return;
    grid.dataset.btInf = '1';
    wrap.style.display = 'none';

    var last = 1;
    document.querySelectorAll('.pagination__list a[href]').forEach(function (a) {
      var m = /[?&]page=(\d+)/.exec(a.getAttribute('href'));
      if (m) last = Math.max(last, parseInt(m[1], 10));
    });
    var curM = /[?&]page=(\d+)/.exec(location.search);
    var page = curM ? parseInt(curM[1], 10) : 1;
    if (page >= last) return;

    var sentinel = document.createElement('div');
    sentinel.className = 'bt-col-more';
    sentinel.innerHTML = '<span class="bt-col-spin"></span>';
    wrap.parentNode.insertBefore(sentinel, wrap);

    var base = location.pathname.replace(/\/$/, '');
    var busy = false, done = false;

    function finish() {
      done = true;
      sentinel.innerHTML = '<span class="bt-col-end">You&rsquo;ve seen them all.</span>';
      io.disconnect();
    }

    function load() {
      if (busy || done) return;
      busy = true;
      var want = page + 1;
      fetch(base + '?page=' + want)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g2 = doc.querySelector('#product-grid') || doc.querySelector('.product-grid, ul.grid');
          var items = g2 ? g2.querySelectorAll(':scope > li, :scope > .grid__item') : [];
          if (!items.length) { busy = false; finish(); return; }
          var frag = document.createDocumentFragment();
          items.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
          markSingle(frag);
          grid.appendChild(frag);
          markSingle(grid);
          grid.querySelectorAll('.bt-nophoto').forEach(function (li) { grid.appendChild(li); });
          page = want;
          busy = false;
          decorate();
          if (page >= last) { finish(); return; }
          if (sentinel.getBoundingClientRect().top < window.innerHeight + 900) setTimeout(load, 80);
        })
        .catch(function () { busy = false; });
    }

    var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) load(); }, { rootMargin: '900px' });
    io.observe(sentinel);
    window.addEventListener('scroll', function () {
      if (!done && !busy && sentinel.getBoundingClientRect().top < window.innerHeight + 900) load();
    }, { passive: true });
  }

  /* ---------- prev / next arrows on product pages ---------- */
  function rememberCollection() {
    if (!/\/collections\//.test(location.pathname) || /\/products\//.test(location.pathname)) return;
    var h = location.pathname.split('/collections/')[1].split('/')[0].split('?')[0];
    try { sessionStorage.setItem('bt-col', h); } catch (e) {}
  }
  function currentCollection() {
    var m = /\/collections\/([^\/?#]+)\/products\//.exec(location.pathname);
    if (m) return m[1];
    var q = /[?&]collection=([^&]+)/.exec(location.search);
    if (q) return decodeURIComponent(q[1]);
    try { return sessionStorage.getItem('bt-col') || 'available-seedlings'; } catch (e) { return 'available-seedlings'; }
  }
  function productArrows() {
    var handle = productHandle();
    if (!handle || document.querySelector('.bt-nav')) return;
    var col = currentCollection();
    fetch('/collections/' + col + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d.products || []).map(function (p) { return { h: p.handle, t: p.title, img: (p.images && p.images[0]) ? p.images[0].src : '' }; });
        var i = -1;
        for (var k = 0; k < list.length; k++) if (list[k].h === handle) { i = k; break; }
        if (i < 0) return;
        var prev = i > 0 ? list[i - 1] : null;
        var next = i < list.length - 1 ? list[i + 1] : null;
        if (!prev && !next) return;
        var host = infoContainer();
        if (!host) return;

        function side(p, dir) {
          if (!p) return '<span class="bt-nav-b bt-nav-empty"></span>';
          var arrow = dir === 'prev' ? '&#8249;' : '&#8250;';
          var thumb = p.img ? '<img src="' + esc(p.img) + '&width=120" alt="" loading="lazy">' : '';
          var inner = dir === 'prev'
            ? '<span class="bt-nav-ar">' + arrow + '</span>' + thumb + '<span class="bt-nav-t">' + esc(p.t) + '</span>'
            : '<span class="bt-nav-t">' + esc(p.t) + '</span>' + thumb + '<span class="bt-nav-ar">' + arrow + '</span>';
          return '<a class="bt-nav-b bt-nav-' + dir + '" href="/collections/' + esc(col) + '/products/' + esc(p.h) + '">' + inner + '</a>';
        }

        var nav = document.createElement('div');
        nav.className = 'bt-nav';
        nav.innerHTML = side(prev, 'prev') + side(next, 'next') +
          '<a class="bt-nav-all" href="/collections/' + esc(col) + '">Back to all ' + list.length + ' plants</a>';
        host.appendChild(nav);

        /* floating tap-anywhere arrows */
        if (!document.querySelector('.bt-fab')) {
          var fab = document.createElement('div');
          fab.className = 'bt-fab';
          var fh = '';
          if (prev) fh += '<a class="bt-fab-b bt-fab-prev" href="/collections/' + esc(col) + '/products/' + esc(prev.h) + '" aria-label="Previous plant">&#8249;</a>';
          if (next) fh += '<a class="bt-fab-b bt-fab-next" href="/collections/' + esc(col) + '/products/' + esc(next.h) + '" aria-label="Next plant">&#8250;</a>';
          fh += '<span class="bt-fab-c">' + (i + 1) + ' / ' + list.length + '</span>';
          fab.innerHTML = fh;
          document.body.appendChild(fab);
        }
      })
      .catch(function () {});
  }

  /* ---------- proof strip on home ---------- */
  function homeStrip() {
    if (location.pathname !== '/') return;
    if (document.querySelector('.bt-strip')) return;
    var main = document.querySelector('main');
    if (!main) return;
    var s = document.createElement('div');
    s.className = 'bt-strip';
    s.innerHTML = '<a href="/pages/arrive-alive"><img src="' + PS_CARD + '" alt="Palmstreet: BowtiePlantCo, 4.9 stars, 1K+ reviews, 17K+ sales">' +
      '<div class="bt-strip-txt"><strong>4.9&#9733; from 1,199 reviews &middot; 17,229 plants shipped</strong>' +
      '<span>Every order backed by our Arrive Alive Guarantee &rarr;</span></div></a>';
    main.insertBefore(s, main.firstChild);
  }


  /* One-line trust strip for cart + collection pages (Nick, 2026-09-05).
     Text only, no image, and inserted ABOVE the items/grid so it never pushes
     any Add / Checkout button down. */
  function trustLine() {
    if (document.querySelector('.bt-trustline')) return;
    var host = null, ref = null;
    if (/^\/cart(\/|$|\?)/.test(location.pathname)) {
      ref = document.querySelector('#main-cart-items .cart__items, .cart__items, cart-items');
    } else if (/\/collections\//.test(location.pathname) && !/\/products\//.test(location.pathname)) {
      ref = document.querySelector('#product-grid') || document.querySelector('.product-grid, ul.grid');
    }
    if (!ref || !ref.parentNode) return;
    host = document.createElement('div');
    host.className = 'bt-trustline';
    host.innerHTML = '<a href="/pages/arrive-alive"><strong>4.9&#9733; &middot; 1,199 reviews &middot; 17,229 plants shipped</strong>' +
      '<span>Arrive Alive Guarantee &rarr;</span></a>';
    ref.parentNode.insertBefore(host, ref);
  }

  /* ---------- Judge.me enhancements ---------- */
  var HIDE_RE = /customer service sucks/i;
  function jmHide() {
    document.querySelectorAll('.jdgm-rev, .jdgm-carousel-item, .jm-review-item').forEach(function (r) {
      if (HIDE_RE.test(r.textContent || '')) r.remove();
    });
  }
  function jmTopBadge() {
    if (!/\/products\//.test(location.pathname)) return;
    if (document.querySelector('.bt-jm-top')) return;
    var sum = document.querySelector('.jdgm-rev-widg__summary');
    var stars = sum && sum.querySelector('.jdgm-rev-widg__summary-stars');
    var txt = sum && sum.querySelector('.jdgm-rev-widg__summary-text');
    if (!stars || !txt || !/review/i.test(txt.textContent || '')) return;
    var h1 = document.querySelector('.product__title h1, .product__title, h1');
    if (!h1) return;
    var a = document.createElement('a');
    a.className = 'bt-jm-top';
    a.href = '#judgeme_product_reviews';
    a.innerHTML = stars.outerHTML + '<span>' + txt.textContent.trim() + '</span>';
    a.addEventListener('click', function (e) {
      var w = document.querySelector('.jdgm-rev-widg');
      if (w) { e.preventDefault(); w.scrollIntoView({ behavior: 'smooth' }); }
    });
    (h1.closest('.product__title') || h1).insertAdjacentElement('afterend', a);
  }
  function jmInfinite() {
    var wrap = document.querySelector('.jdgm-all-reviews-widget, .jdgm-rev-widg');
    if (!wrap) return;
    var pag = wrap.querySelector('.jdgm-paginate');
    if (!pag) return;
    var next = pag.querySelector('.jdgm-paginate__next-page');
    pag.style.visibility = 'hidden';
    pag.style.height = '1px';
    if (!next) return;
    if (pag.dataset.btIo) return;
    pag.dataset.btIo = '1';
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting) return;
        var n = wrap.querySelector('.jdgm-paginate__next-page');
        if (n) { n.click(); } else { io.disconnect(); }
      });
    }, { rootMargin: '600px' });
    io.observe(pag);
  }

  /* own infinite-scroll review list */
  function esc(t) { return (t || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function revHtml(r) {
    var stars = '';
    for (var i = 1; i <= 5; i++) stars += '<span class="bt-rv-star' + (i <= r.r ? ' on' : '') + '">&#9733;</span>';
    var pics = (r.p || []).map(function (u) { return '<img loading="lazy" onerror="this.remove()" src="' + esc(u) + '" alt="">'; }).join('');
    return '<li class="bt-rv">' +
      '<div class="bt-rv-head"><span class="bt-rv-stars">' + stars + '</span><span class="bt-rv-date">' + esc(r.d) + '</span></div>' +
      '<div class="bt-rv-name">' + esc(r.n) + '</div>' +
      (pics ? '<div class="bt-rv-pics">' + pics + '</div>' : '') +
      '<div class="bt-rv-body">' + esc(r.b) + '</div>' +
      (r.t ? '<div class="bt-rv-prod">on ' + esc(r.t) + '</div>' : '') + '</li>';
  }
  function ownReviews() {
    var host = document.getElementById('bt-revs');
    if (!host || host.dataset.btInit) return;
    host.dataset.btInit = '1';
    var more = document.getElementById('bt-revs-more');

    fetch(host.dataset.src).then(function (r) { return r.json(); }).then(function (all) {
      var ul = document.createElement('ul');
      ul.className = 'bt-rv-list';
      host.appendChild(ul);
      var i = 0, N = 12;
      function batch() {
        var html = '';
        for (var k = 0; k < N && i < all.length; k++, i++) html += revHtml(all[i]);
        ul.insertAdjacentHTML('beforeend', html);
        if (i >= all.length) { io.disconnect(); if (more) more.innerHTML = '<span>That&rsquo;s all ' + all.length + ' reviews.</span>'; }
      }
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) batch(); }, { rootMargin: '700px' });
      batch();
      if (more) io.observe(more);
    }).catch(function () { if (more) more.style.display = 'none'; });
  }
  function jmHideTabs() {
    document.querySelectorAll('.bt-jdgm-all-reviews a, .bt-jdgm-all-reviews button, .bt-jdgm-all-reviews [role="tab"]').forEach(function (a) {
      if (/Reviews\s*\(\d/i.test((a.textContent || '').trim())) {
        var w = a.closest('[class*="tab"]') || a.parentElement || a;
        w.style.display = 'none';
      }
    });
  }
  function jmTick() { jmHide(); jmTopBadge(); ownReviews(); jmHideTabs(); }


  /* ---------- add-on offer under the Add-to-cart button (Nick, 2026-09-05) ----------
     The $12.50 mystery-seedling add-on only lived in the cart/checkout. Nick wanted it
     offered on plant product pages too. Limit 2 per order is enforced client-side. */
  var ADDON_VARIANT = 44072808906811;
  var ADDON_HANDLE = 'add-on-mystery-seedling';
  function addonOffer() {
    var handle = productHandle();
    if (!handle || handle === ADDON_HANDLE || handle === SUBSTRATE_HANDLE) return;
    if (!seedHandles[handle] && handle !== MYSTERY_HANDLE) return;
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form || form.dataset.btAddon) return;
    var submit = form.querySelector('.product-form__submit, [type="submit"]');
    if (!submit) return;
    form.dataset.btAddon = '1';
    var d = document.createElement('div');
    d.className = 'bt-addon';
    d.innerHTML = '<div class="bt-addon-t">Add a mystery seedling <strong data-live-price style="display:none"></strong></div>' +
      '<div class="bt-addon-s">A hand-picked anthurium seedling ($25&ndash;$50 value), ships free in the same box. Limit 2.</div>' +
      '<button type="button" class="bt-addon-btn">Add to cart</button>';
    livePrice(d, ADDON_HANDLE, ADDON_VARIANT);
    var btn = d.querySelector('.bt-addon-btn');
    btn.addEventListener('click', function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var have = 0;
        (c.items || []).forEach(function (i) { if (i.variant_id === ADDON_VARIANT) have += i.quantity; });
        if (have >= 2) { btn.disabled = true; btn.textContent = 'Limit 2 reached'; return; }
        addToCart(ADDON_VARIANT, btn, '&#10003; Added');
      });
    });
    (submit.parentNode === form ? form : submit.parentNode).insertBefore(d, submit.nextSibling);
  }

  /* ---------- cart page: quick-add seedlings when short of the 4th-free (Nick, 2026-09-05) ---------- */
  function cartSeedPicker(cart) {
    /* Retired with B3G4 2026-10-17 (Nick). Set window.BT_CART_ROLLER = true to bring back. */
    if (window.BT_CART_ROLLER !== true) { var h0 = document.getElementById('bt-cart-pick'); if (h0) h0.remove(); return; }
    if (!/^\/cart(\/|$|\?)/.test(window.location.pathname)) return;
    var b = bar;
    if (!b || !b.classList.contains('bt-inline')) return;
    var n = seedCount(cart);
    var host = document.getElementById('bt-cart-pick');
    if (n >= 4 && n % 4 === 0) { if (host) host.remove(); return; }
    if (host) return;
    /* Only real single seedlings — the mystery pack, the subscription box and add-ons
       are not "one more seedling" (Nick, 2026-09-05). */
    var SKIP = /mystery|subscription|bowtie-box|add-on|substrate|dirty-bowtie|gift-card/i;
    var pool = seedList.filter(function (h) {
      var i = seedHandles[h];
      return i && !SKIP.test(h) && !SKIP.test(i.title || '');
    });
    if (!pool.length) return;
    /* Nick, 2026-09-05: hearts + a back button on the cart roller too. */
    var locked = [];   // handles the shopper wants kept across rolls
    var hist = [];     // previous offers, newest last
    var cur = [];
    function pickFour() {
      var keep = locked.slice(0, 4);
      var rest = pool.filter(function (h) { return keep.indexOf(h) === -1; })
        .sort(function () { return Math.random() - 0.5; }).slice(0, 4 - keep.length);
      return keep.concat(rest);
    }
    var picks = pickFour();
    host = document.createElement('div');
    host.id = 'bt-cart-pick';
    var need = n < 3 ? (3 - n) : 1;
    host.innerHTML = '<div class="bt-cp-h">' + (n === 0
        ? 'Start your set &mdash; buy 3 seedlings, get the 4th free'
        : 'You\u2019re ' + need + ' seedling' + (need > 1 ? 's' : '') + ' from a free one') + '</div>' +
      '<div class="bt-cp-row"></div>';
    var row = host.querySelector('.bt-cp-row');
    function renderPicks(picks) {
      cur = picks.slice();
      crtSee(picks);
      row.innerHTML = '';
    picks.forEach(function (h) {
        var info = seedHandles[h];
        if (!info) return;
        var c = document.createElement('div');
        c.className = 'bt-cp-card';
        /* Swipeable photo strip (scroll-snap) + always show the plant name (Nick, 2026-09-05).
           Dark card styling: white boxes on the dark cart page looked awful. */
        var imgs = (info.imgs && info.imgs.length ? info.imgs : (info.img ? [info.img] : []));
        var media = imgs.length
          ? '<div class="bt-cp-media">' + imgs.map(function (u) {
              return '<a class="bt-cp-slide" href="/products/' + h + '"><img loading="lazy" src="' + u + '&width=400" alt=""></a>';
            }).join('') + '</div>' + (imgs.length > 1 ? '<div class="bt-cp-dots">' + imgs.map(function (u, i) {
              return '<span class="bt-cp-dot' + (i === 0 ? ' on' : '') + '"></span>'; }).join('') + '</div>' : '')
          : '';
        var isLock = locked.indexOf(h) !== -1;
        c.innerHTML = media +
          '<div class="bt-cp-keep' + (isLock ? ' is-on' : '') + '" role="button" tabindex="0" ' +
            'aria-pressed="' + isLock + '" aria-label="' + (isLock ? 'Locked in' : 'Lock this one in') + '">' +
            '<span class="bt-cp-heart">' + (isLock ? '&#10084;' : '&#9825;') + '</span>' +
            '<span class="bt-cp-keeplbl">' + (isLock ? 'Locked in' : 'Lock it in') + '</span>' +
          '</div>' +
          '<a class="bt-cp-t" href="/products/' + h + '">' + info.title + '</a>' +
          '<button type="button" class="bt-cp-btn">Add &middot; $' + info.price + '</button>';
        var strip = c.querySelector('.bt-cp-media');
        if (strip && imgs.length > 1) {
          var dots = c.querySelectorAll('.bt-cp-dot');
          strip.addEventListener('scroll', function () {
            var i = Math.round(strip.scrollLeft / strip.clientWidth);
            dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
          }, { passive: true });
          /* Tap advances to the next photo instead of opening the product */
          strip.addEventListener('click', function (e) {
            var i = Math.round(strip.scrollLeft / strip.clientWidth);
            if (i < imgs.length - 1) {
              e.preventDefault();
              strip.scrollTo({ left: (i + 1) * strip.clientWidth, behavior: 'smooth' });
            }
          });
        }
        if (isLock) c.classList.add('bt-cp-locked');
        c.querySelector('.bt-cp-keep').addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var at = locked.indexOf(h);
          if (at === -1) { if (locked.length < 3) { locked.push(h); CRT.locks++; crtLog('lock', h); } } else { locked.splice(at, 1); crtLog('unlock', h); }
          renderPicks(cur);
        });
        c.querySelector('.bt-cp-btn').addEventListener('click', function (e) {
          var won = c.classList.contains('bt-cp-win');
          crtLog(won ? 'add-winner' : 'add', h);
          addToCart(info.id, e.currentTarget, null, {
            '_roller': 'cart',
            '_roller_won': won ? 'yes' : 'no',
            '_roller_rolls': String(CRT.rolls)
          }).then(function () {
            return crtStamp(info.title + (won ? ' (roller pick)' : ''));
          }).then(function () { setTimeout(function () { location.reload(); }, 400); });
        });
        row.appendChild(c);
      });
    }
    renderPicks(picks);
    b.parentNode.insertBefore(host, b.nextSibling);
    function pushHist() { if (cur.length) { hist.push(cur.slice()); if (hist.length > 8) hist.shift(); } }
    function hasHistory() { return hist.length > 0; }
    function back() {
      var prev = hist.pop();
      if (!prev) return null;
      renderPicks(prev);
      return prev;
    }
    cartRoller(host, row, renderPicks, pickFour, back, hasHistory, pushHist);
  }

  /* ---------- cart page: roll for your next seedling (Nick, 2026-09-05) ----------
     Nick liked the roller, so the cart picker gets the slot-machine moment without
     the full cabinet: the four cards flicker, decelerate and one lights up gold.
     Pure setTimeout chain (no observers, no rAF loops left running). */
  function cartRoller(host, row, renderPicks, pickFour, back, hasHistory, push) {
    /* KILLSWITCH (Nick, 2026-09-06): set window.BT_CART_ROLLER = false anywhere before
       this runs (theme.liquid script, or Custom Liquid block) and the cart page falls
       back to the plain seedling grid with no slot-machine. The homepage roller has its
       own switch: the "Build my pack" section's hide toggle in the theme editor. */
    if (window.BT_CART_ROLLER !== true) return; /* retired 2026-10-17 (Nick): set BT_CART_ROLLER = true to bring back */
    if (row.querySelectorAll('.bt-cp-card').length < 2) return;
    var cards = [];
    var bar = document.createElement('div');
    bar.className = 'bt-cp-spinbar';
    bar.innerHTML = '<button type="button" class="bt-cp-back" hidden title="Go back to the previous roll" aria-label="Go back to the previous roll"><span class="bt-cp-backic">&#8630;</span><span class="bt-cp-backlbl">Go back</span></button>' +
      '<button type="button" class="bt-cp-spin">&#127807; Roll me a seedling</button>' +
      '<span class="bt-cp-spinnote">Can&rsquo;t decide? Let the roller pick.</span>';
    host.insertBefore(bar, row);
    var btn = bar.querySelector('.bt-cp-spin'), spinning = false;
    var backBtn = bar.querySelector('.bt-cp-back');
    if (back) {
      backBtn.addEventListener('click', function () {
        if (spinning) return;
        var prev = back();
        if (!prev) return;
        CRT.backs++; crtLog('go-back');
        backBtn.hidden = !hasHistory();
      });
    }
    btn.addEventListener('click', function () {
      if (spinning) return;
      spinning = true;
      btn.disabled = true;
      /* Nick, 2026-09-05: a re-roll has to deal NEW seedlings, not relight the same four. */
      CRT.rolls++; crtLog('roll');
      if (renderPicks && pickFour) { if (push) push(); renderPicks(pickFour()); }
      if (backBtn && hasHistory) backBtn.hidden = !hasHistory();
      cards = [].slice.call(row.querySelectorAll('.bt-cp-card'));
      cards.forEach(function (c) { c.classList.remove('bt-cp-win', 'bt-cp-lit'); });
      var i = 0, step = 70, total = 0, target = 1400 + Math.floor(Math.random() * 700);
      function tick() {
        cards.forEach(function (c, k) { c.classList.toggle('bt-cp-lit', k === i % cards.length); });
        i++;
        total += step;
        if (total >= target && step > 190) {
          var win = cards[(i - 1) % cards.length];
          cards.forEach(function (c) { c.classList.remove('bt-cp-lit'); });
          win.classList.add('bt-cp-win');
          try { win.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' }); } catch (e) {}
          var wb = win.querySelector('.bt-cp-btn');
          if (wb && !/Added/.test(wb.innerHTML)) wb.innerHTML = 'Add this one &middot; $' + (wb.textContent.split('$')[1] || '');
          btn.disabled = false;
          btn.innerHTML = '&#8635; Roll again';
          spinning = false;
          return;
        }
        if (total >= target) step = Math.round(step * 1.35);
        setTimeout(tick, step);
      }
      tick();
    });
  }

  function init() {
    loadSeedlings().then(function () {
      decorate();
      productPage();
      addonOffer();
      sinkSinglePhoto();
      colInfinite();
      rememberCollection();
      productArrows();
      homeStrip();
      trustLine();
      refresh();
      jmTick();
      /* Throttled: raw per-mutation work on this DOM is a performance trap (see the
         applyVisibility note above). Coalesce bursts into one pass per 250ms. */
      var mtTimer = null;
      new MutationObserver(function () {
        if (mtTimer) return;
        mtTimer = setTimeout(function () { mtTimer = null; decorate(); addonOffer(); jmTick(); }, 250);
      }).observe(document.body, { childList: true, subtree: true });
      var jmN = 0, jmT = setInterval(function () { jmTick(); if (++jmN > 40) clearInterval(jmT); }, 500);
      document.addEventListener('cart:refresh', refresh);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Wordmark under the header logo (Nick, 2026-09-05) */
  function addWordmark() {
    var link = document.querySelector('.header__heading-link');
    if (!link || link.querySelector('.bt-wordmark')) return;
    if (!link.querySelector('.header__heading-logo')) return;
    var s = document.createElement('span');
    s.className = 'bt-wordmark';
    s.textContent = 'Bowtie Plant Co.';
    link.appendChild(s);
  }
  document.addEventListener('DOMContentLoaded', addWordmark);
  addWordmark();
})();

/* ==========================================================================
   bt-track — first-party shopper analytics (Nick, 2026-09-07)
   Answers "which surface actually sells", "what do people search for that we
   don't stock", "what sells out that we should grow", "which photo converts".
   Events go to the Bowtie Data space collector. Fire-and-forget: nothing here
   may ever block or break an add-to-cart.
   ========================================================================== */
(function () {
  var ENDPOINT = 'https://exciting-mink-405.convex.site/collect';
  if (window.BT_TRACK === false) return;              // killswitch

  var sid = '', tester = '';
  try {
    var ss = window.sessionStorage;
    sid = ss.getItem('bwt_sid') || (Date.now().toString(36) + Math.random().toString(36).slice(2, 7));
    ss.setItem('bwt_sid', sid);
    var qt = (location.search.match(/[?&]rollertest=([^&]+)/) || [])[1];
    if (qt) ss.setItem('bwt_tester', decodeURIComponent(qt));
    tester = ss.getItem('bwt_tester') || '';
  } catch (e) { sid = Math.random().toString(36).slice(2, 9); }
  if (!tester && navigator.webdriver) tester = 'automation';

  function who() {
    if (tester) return 'TEST:' + tester;
    var cid = '';
    try {
      cid = (window.__st && window.__st.cid) ||
        (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page &&
          ShopifyAnalytics.meta.page.customerId) || '';
    } catch (e) {}
    return cid ? 'customer ' + cid : 'guest';
  }

  var q = [], timer = null;
  function flush(sync) {
    if (!q.length) return;
    var payload = JSON.stringify({ events: q.splice(0, 40) });
    try {
      if (sync && navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([payload], { type: 'application/json' }));
        return;
      }
      fetch(ENDPOINT, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: payload, keepalive: true, mode: 'cors'
      }).catch(function () {});
    } catch (e) {}
  }
  function send(type, extra) {
    var e = extra || {};
    e.type = type; e.sid = sid; e.who = who(); e.ts = Date.now();
    e.path = location.pathname;
    q.push(e);
    if (q.length >= 12) { flush(false); return; }
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { flush(false); }, 2500);
  }
  window.addEventListener('pagehide', function () { flush(true); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush(true);
  });

  /* ---- page + product view ---- */
  var refHost = '';
  try { refHost = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) {}
  if (refHost && refHost.indexOf(location.hostname) !== -1) refHost = '';
  var pm = null;
  try { pm = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product; } catch (e) {}
  var pHandle = (location.pathname.match(/\/products\/([^?#\/]+)/) || [])[1] || '';
  var pTitle = '';
  try {
    pTitle = (document.querySelector('.product__title h1, h1.product__title, .product__info-wrapper h1') || {}).textContent || '';
    pTitle = pTitle.trim();
  } catch (e) {}

  send('page_view', { ref: refHost || undefined });
  if (pHandle) {
    send('product_view', { handle: pHandle, title: pTitle || undefined, ref: refHost || undefined });
    /* sold-out interest: they landed on a plant they cannot buy */
    setTimeout(function () {
      var btn = document.querySelector('button[name="add"], .product-form__submit');
      var txt = btn ? (btn.textContent || '') : '';
      if (btn && (btn.disabled || /sold\s*out|unavailable/i.test(txt))) {
        send('soldout_interest', { handle: pHandle, title: pTitle || undefined });
      }
    }, 1200);
  }

  /* ---- which surface: remember the last thing they touched ---- */
  var SURFACES = [
    ['.bw-mach, [data-roll-add], [data-roll-buy], #bw-roller', 'roller'],
    ['#bt-cart-pick', 'cart-picker'],
    ['.bt-qa', 'collection-quickadd'],
    ['.bt-addon, [data-bt-addon]', 'addon-upsell'],
    ['.bt-bar, .bt-fab', 'b3g4-bar'],
    ['.bt-home-strip, #bt-home-strip', 'home-strip'],
    ['product-form, .product-form, form[action*="/cart/add"]', 'product-page'],
    ['.card-wrapper, .card, .grid__item', 'collection-card']
  ];
  var lastSource = '', lastCtx = {};
  document.addEventListener('pointerdown', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    for (var i = 0; i < SURFACES.length; i++) {
      if (el.closest(SURFACES[i][0])) {
        lastSource = SURFACES[i][1];
        var a = el.closest('[href*="/products/"]') || (el.closest('.card-wrapper, .bt-cp-card, .bw-rc') || document.body).querySelector('[href*="/products/"]');
        var h = a ? (a.getAttribute('href').match(/\/products\/([^?#\/]+)/) || [])[1] : (pHandle || '');
        lastCtx = { handle: h || undefined };
        return;
      }
    }
  }, true);
  function currentSource() {
    if (lastSource) return lastSource;
    if (pHandle) return 'product-page';
    return 'other';
  }

  /* ---- stamp _source on EVERY add-to-cart, whichever path it takes ---- */
  function stamp(items) {
    var src = currentSource();
    (items || []).forEach(function (it) {
      if (!it || typeof it !== 'object') return;
      it.properties = it.properties || {};
      if (!it.properties._source && !it.properties._roller) it.properties._source = src;
      if (it.properties._roller) it.properties._source = it.properties._source || 'roller';
    });
    return src;
  }
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (/\/cart\/add(\.js)?/.test(url) && init && typeof init.body === 'string') {
        var b = JSON.parse(init.body);
        var items = b.items || (b.id ? [b] : null);
        if (items) {
          var src = stamp(items);
          init.body = JSON.stringify(b);
          items.forEach(function (it) {
            send('add_to_cart', {
              source: src,
              handle: lastCtx.handle || pHandle || undefined,
              title: pTitle || undefined,
              value: typeof it.price === 'number' ? it.price : undefined
            });
          });
        }
      }
    } catch (e) {}
    return _fetch.apply(this, arguments);
  };
  /* non-JS theme adds: full page form POST */
  document.addEventListener('submit', function (e) {
    try {
      var f = e.target;
      if (!f || !f.action || !/\/cart\/add/.test(f.action)) return;
      if (!f.querySelector('[name="properties[_source]"]')) {
        var inp = document.createElement('input');
        inp.type = 'hidden'; inp.name = 'properties[_source]'; inp.value = currentSource();
        f.appendChild(inp);
      }
      send('add_to_cart', { source: currentSource(), handle: pHandle || undefined, title: pTitle || undefined });
    } catch (err) {}
  }, true);

  /* ---- search terms + zero-result searches ---- */
  var seenTerm = {};
  function logSearch(term, results) {
    term = (term || '').trim().toLowerCase();
    if (term.length < 3) return;
    var key = term + '|' + (results === 0 ? 'z' : 'r');
    if (seenTerm[key]) return;
    seenTerm[key] = 1;
    send(results === 0 ? 'search_zero' : 'search', { term: term, results: results });
  }
  function watchSearch() {
    document.querySelectorAll('input[name="q"]').forEach(function (inp) {
      if (inp.dataset.btTrk) return;
      inp.dataset.btTrk = '1';
      var t = null;
      inp.addEventListener('input', function () {
        if (t) clearTimeout(t);
        var val = inp.value;
        t = setTimeout(function () {
          if (val.trim().length < 3) return;
          /* ask the storefront how many results that term actually has */
          fetch('/search/suggest.json?q=' + encodeURIComponent(val) + '&resources[type]=product&resources[limit]=10')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var n = ((d.resources || {}).results || {}).products || [];
              logSearch(val, n.length);
            }).catch(function () {});
        }, 1000);
      });
    });
  }
  watchSearch();
  setInterval(watchSearch, 2000);
  /* /search results page */
  if (/^\/search/.test(location.pathname)) {
    var term = (location.search.match(/[?&]q=([^&]*)/) || [])[1] || '';
    if (term) {
      setTimeout(function () {
        var n = document.querySelectorAll('.card-wrapper, .grid__item .card, product-card').length;
        logSearch(decodeURIComponent(term.replace(/\+/g, ' ')), n);
      }, 900);
    }
  }

  /* ---- sold-out interest from listings ---- */
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var card = el.closest('.card-wrapper, .card, .grid__item');
    if (!card) return;
    var badge = card.querySelector('.badge, .card__badge');
    if (!badge || !/sold\s*out|unavailable/i.test(badge.textContent || '')) return;
    var a = card.querySelector('[href*="/products/"]');
    var h = a ? (a.getAttribute('href').match(/\/products\/([^?#\/]+)/) || [])[1] : undefined;
    var t = (card.querySelector('.card__heading, .card-information__text, h3') || {}).textContent || '';
    send('soldout_interest', { handle: h, title: t.trim() || undefined });
  }, true);

  /* ---- which photo they were on ---- */
  var photoSeen = {};
  function photo(idx) {
    if (idx === undefined || idx === null || photoSeen[idx]) return;
    photoSeen[idx] = 1;
    send('photo_view', { photoIndex: idx, handle: pHandle || undefined, title: pTitle || undefined });
  }
  if (pHandle) {
    document.addEventListener('click', function (e) {
      var th = e.target.closest && e.target.closest('.thumbnail, .thumbnail-list__item button, [data-media-position]');
      if (!th) return;
      var pos = th.getAttribute('data-media-position');
      if (pos) { photo(parseInt(pos, 10) - 1); return; }
      var list = th.closest('.thumbnail-list, .product__media-list');
      if (list) photo([].indexOf.call(list.children, th.closest('li') || th));
    }, true);
    var media = document.querySelector('.product__media-list, .product-media-container');
    if (media) {
      media.addEventListener('scroll', function () {
        photo(Math.round(media.scrollLeft / Math.max(1, media.clientWidth)));
      }, { passive: true });
    }
    photo(0);
  }

  /* ---- checkout intent ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('#checkout, [name="checkout"], .cart__checkout-button');
    if (b) send('checkout_click', {});
  }, true);
})();
